// Utility function for GBCS (placeholder)
export const gbcsFunction = () => {
  // Add your logic here
};

// Grid helper functions (placeholder object)
export const gridHelpers = {
  // Add helper methods here if needed
};

// Default column parameters for AG Grid
export const defaultColParas = () => ({
  flex: 1,
  lockPinned: true,
  sortable: true,
  resizable: true,
  textAlign: "center",
  suppressMovable: true,
  minWidth: 150,
  enableCellChangeFlash: true,
  filterParams: {
    buttons: ["reset", "apply"],
    closeOnApply: true,
    defaultJoinOperator: "OR",
  },
  filter: "agTextColumnFilter",
  stopEditingWhenCellsLoseFocus: true,
});

// Reset all filters in AG Grid
export const resetAllFilter = (gridRef) => {
  if (gridRef?.current?.api) {
    gridRef.current.api.setFilterModel(null);
  }
};

// Reset a specific filter in AG Grid
export const resetFilter = (gridRef, item, feildName) => {
  const index = item.indexOf(":");
  if (index > 0) {
    const item1 = item.substring(0, index - 1);
    const col = gridRef.current.api.getFilterModel();
    for (const key of Object.keys(col)) {
      if (key === feildName(item1)) {
        delete col[key];
      }
    }
    gridRef.current.api.setFilterModel(col);
  }
};

// Handle filter changes in AG Grid
export const FilterChange = (
  param,
  setFilteredCol,
  headerName,
  setRowData,
  setExcelData
) => {
  setFilteredCol([]);
  setRowData([]);

  const col = param.api.getFilterModel();

  if (param.api.getDisplayedRowCount() === 0) {
    param.api.showNoRowsOverlay();
  } else {
    param.api.hideOverlay();
  }

  const temp = [];
  param.api.forEachNodeAfterFilter((node) => {
    temp.push(node.data);
  });
  setRowData(temp);
  setExcelData(temp);

  if (Object.keys(col).length === 0) return;

  for (const key of Object.keys(col)) {
    let filter = "";
    const filterObj = col[key];

    if (filterObj.filterType === "date") {
      if (filterObj.condition1) {
        const fromDate1 = filterObj.condition1.dateFrom || "";
        const toDate1 = filterObj.condition1.dateTo || "";
        const fromDate2 = filterObj.condition2?.dateFrom || "";
        const toDate2 = filterObj.condition2?.dateTo || "";

        filter = `${headerName(key)} : ${fromDate1}${toDate1 ? " To " + toDate1 : ""}, ${fromDate2}${toDate2 ? " To " + toDate2 : ""}`;
      } else {
        filter = `${headerName(key)} : ${filterObj.dateFrom?.substring(0, 10)}${filterObj.dateTo ? " To " + filterObj.dateTo?.substring(0, 10) : ""}`;
      }
    } else if (filterObj.filterType === "number") {
      if (filterObj.condition1) {
        filter = `${headerName(key)} : ${filterObj.condition1.filter}${filterObj.condition1.filterTo ? " To " + filterObj.condition1.filterTo : ""}, ${filterObj.condition2.filter}${filterObj.condition2.filterTo ? " To " + filterObj.condition2.filterTo : ""}`;
      } else {
        filter = `${headerName(key)} : ${filterObj.filter}${filterObj.filterTo ? " To " + filterObj.filterTo : ""}`;
      }
    } else {
      if (filterObj.condition1) {
        filter = `${headerName(key)} : ${filterObj.condition1.filter}, ${filterObj.condition2.filter}`;
      } else {
        filter = `${headerName(key)} : ${filterObj.filter}`;
      }
    }

    setFilteredCol((prev) => [...prev, filter]);
  }
};

// Export all as default object
export default {
  gbcsFunction,
  gridHelpers,
  defaultColParas,
  resetFilter,
  resetAllFilter,
  FilterChange,
};
